<template>
    <div class="py-16 px-20 text-16 font-600 text-#262642 border-b-solid border-b-1 border-b-#D9d9d9">{{ t('message.messageCenter') }}</div>
    <div v-if="messageList.length === 0" class="message-empty flex-center flex-col gap-12">
        <img src="@/assets/imgs/zanwuxiaoxi.svg" alt="message_empty" class="w-90" />
        {{ t('message.noMessage') }}
    </div>
    <div v-else class="message-list">
        <div class="flex flex-col gap-20">
            <div v-for="item in messageList" :key="item.id" class="message-item" @click="handleClickMessage(item)">
                <div class="message-icon">
                    <img src="@/assets/imgs/system_notice.svg" alt="message_center_icon" class="w-16" />
                    <span v-if="!item.is_read" class="message-unread-dot"></span>
                </div>
                <div class="flex-1 min-w-0">
                    <div class="message-title">{{ item.title }}</div>
                    <div class="flex items-center justify-between mt-8">
                        <span class="message-content">
                            {{ formatMessageSnippet(item.snippet) }}
                        </span>
                        <span class="message-time">{{ formatMessageTime(item.sent_at) }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="message-footer flex justify-end align-center">
            <span class="flex justify-end align-center gap-4 cursor-pointer" @click="handleViewAll">
                {{ t('message.viewAll') }}
                <icon-svg-left_arrow class="text-#1E64FA"></icon-svg-left_arrow>
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs';
import { useI18n } from 'vue-i18n';
import { LocaleTypeEnum } from '@/store/locale';
import { formatMessageSnippet } from '@/utils/commonFun';
const emit = defineEmits<{ (e: 'close'): void }>();
const { t } = useI18n();
const router = useRouter();
const { getCurrentLocale } = useStore('locale');

const { headerMessageList } = useStore('common');
// header 弹窗的消息列表由 Header.vue 统一拉取并写入 store
const messageList = headerMessageList;

const handleClickMessage = (item: any) => {
    emit('close');
    router.push({ path: '/MessageDetail', query: { id: item.id } });
};

const handleViewAll = () => {
    emit('close');
    router.push('/MessageCenter');
};

const formatMessageTime = (value: number | string) => {
    if (!value) {
        return '-';
    }

    const messageTime = dayjs(value);
    if (!messageTime.isValid()) {
        return '-';
    }

    const now = dayjs();
    const diffMinutes = now.diff(messageTime, 'minute');
    if (diffMinutes < 60) {
        const minutes = Math.max(diffMinutes, 1);
        return getCurrentLocale.value == LocaleTypeEnum.English ? `${minutes} minutes ago` : `${minutes}分钟前`;
    }

    const diffHours = now.diff(messageTime, 'hour');
    if (diffHours < 24) {
        return getCurrentLocale.value == LocaleTypeEnum.English ? `${diffHours} hours ago` : `${diffHours}小时前`;
    }

    const diffDays = now.diff(messageTime, 'day');
    if (diffDays <= 30) {
        return getCurrentLocale.value == LocaleTypeEnum.English ? `${Math.max(diffDays, 1)} days ago` : `${Math.max(diffDays, 1)}天前`;
    }

    return dayjs(messageTime).format('YYYY-MM-DD');
};
</script>

<style scoped lang="scss">
.message-list {
    width: 400px;
    max-height: 675px;
    overflow-y: auto;
    padding: 24px 20px 0 20px;
}

.message-empty {
    padding: 40px 0 56px;
    text-align: center;
    color: #999;
    font-size: 14px;
}

.message-item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 0;
    border-radius: 10px;
    background: #fff;
    cursor: pointer;
    transition: all 0.2s;

    .message-icon {
        position: relative;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: #e8effe;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .message-unread-dot {
        position: absolute;
        right: -2px;
        top: 0;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #ff294b;
        border: 2px solid #fff;
    }

    .message-title {
        font-size: 14px;
        font-weight: 500;
        color: #262642;
        line-height: 1.4;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .message-content {
        font-size: 12px;
        color: #999;
        line-height: 1.4;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .message-time-wrap {
        display: flex;
        align-items: center;
        gap: 4px;
        color: #999;
        font-size: 14px;
        flex-shrink: 0;
    }

    .message-time {
        font-size: 12px;
        color: #999;
        white-space: nowrap;
        margin-left: 18px;
    }
}

.message-footer {
    padding: 16px 0;
    text-align: right;
    font-size: 12px;
    color: #1e64fa;
    border-top: 1px solid #f0f0f0;
    margin-top: 24px;
}
</style>
